import { ATSPrincipalAppCandidateModalTabsTestIds } from 'data-testids/ATS';
import { AttachmentButton, AttachmentSizeAndTypeText, AttachmentTitle } from '../../styles';
import { AttachmentsInfoTabProps } from 'features/Principal/types/modalTypes';
import { Box, Stack, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import { bytesToSize } from 'utils/util';

export const AttachmentItem = ({ attachment }) => {
  const formatFileType = (fileType: string) => {
    if (!fileType) return null;
    return `${fileType.toUpperCase()} Document`;
  };

  const fileType = formatFileType(attachment.file_type);
  const fileSize = bytesToSize(attachment.file_size);

  return (
    <AttachmentButton
      href={attachment.attachment}
      target="_blank"
      data-testid={ATSPrincipalAppCandidateModalTabsTestIds.ATTACHMENT_ITEM}
    >
      <Stack direction="row" alignItems="center" sx={{ width: '50%' }}>
        <FeedOutlinedIcon fontSize="large" />
        <Stack direction="column" sx={{ pl: 1 }}>
          <AttachmentTitle data-testid={ATSPrincipalAppCandidateModalTabsTestIds.ATTACHMENT_TITLE}>
            {attachment.file_name || attachment.title}
          </AttachmentTitle>
          <Stack direction="row">
            <AttachmentSizeAndTypeText
              sx={{
                pr: 0.5,
              }}
              data-testid={ATSPrincipalAppCandidateModalTabsTestIds.ATTACHMENT_FILE_TYPE}
            >
              {fileType}
            </AttachmentSizeAndTypeText>
            {fileType && fileSize && <Typography>•</Typography>}
            <AttachmentSizeAndTypeText
              sx={{
                pl: 0.5,
              }}
              data-testid={ATSPrincipalAppCandidateModalTabsTestIds.ATTACHMENT_FILE_SIZE}
            >
              {fileSize || ''}{' '}
            </AttachmentSizeAndTypeText>
          </Stack>
        </Stack>
      </Stack>
      <AttachFileIcon sx={{ transform: 'rotate(45deg)' }}></AttachFileIcon>
    </AttachmentButton>
  );
};

export const AttachmentsInfoTab: React.FC<AttachmentsInfoTabProps> = ({ attachments }) => {
  if (!attachments || attachments.length === 0) {
    return (
      <Typography data-testid={ATSPrincipalAppCandidateModalTabsTestIds.NO_ATTACHMENTS_MESSAGE}>
        No additional attachments were included with this application.
      </Typography>
    );
  }

  return (
    <Box data-testid={ATSPrincipalAppCandidateModalTabsTestIds.ATTACHMENTS_INFO_TAB}>
      <Typography sx={{ pb: 2 }}>Documents submitted with this application:</Typography>
      {attachments.map((attachment, index) => (
        <AttachmentItem key={index} attachment={attachment} />
      ))}
    </Box>
  );
};
